(function () {
  'use strict';

  /* ── Mode éditeur Shopify Customizer ── */
  if (window.apEditorMode) {
    var _popup = document.getElementById('apPopup');
    var _toast = document.getElementById('apToast');

    if (window.apEditorMode === 'toast') {
      if (_popup) _popup.style.display = 'none';
      if (_toast) _toast.classList.add('is-visible');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      return;
    }

    if (window.apEditorMode === 'hidden') {
      if (_popup) _popup.style.display = 'none';
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      return;
    }
    if (_popup) {
      _popup.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    }
    if (window.apEditorMode === 'expired') {
      if (_popup) _popup.classList.add('is-expired');
    }
    return;
  }

  var STORAGE_KEY = 'acces_prive';
  function getAccess() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; }
    catch (e) { return {}; }
  }
  function setAccess(data) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }

  /* ── AB TEST : countdown live vs statique (window.apCountdownLive) ── */
  function startApCountdown(expiresAtISO) {
    var end = new Date(expiresAtISO).getTime();
    if (!isFinite(end)) return;
    var elD = document.getElementById('apDays');
    var elH = document.getElementById('apHours');
    var elM = document.getElementById('apMinutes');
    var elS = document.getElementById('apSeconds');
    if (!elD && !elH && !elM && !elS) return;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var t = Math.max(0, end - Date.now());
      var totalSec = Math.floor(t / 1000);
      var d = Math.floor(totalSec / 86400); totalSec %= 86400;
      var h = Math.floor(totalSec / 3600);  totalSec %= 3600;
      var m = Math.floor(totalSec / 60);
      var s = totalSec % 60;
      if (elD) elD.textContent = d;
      if (elH) elH.textContent = pad(h);
      if (elM) elM.textContent = pad(m);
      if (elS) elS.textContent = pad(s);
      if (t <= 0) clearInterval(timer);
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  function trackEvent(name, params) {
    params = params || {};
    if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, params));
    if (window.gtag)      window.gtag('event', name, params);
    if (window.fbq)       window.fbq('trackCustom', name, params);
    var url = window.apConfig && window.apConfig.trackingUrl;
    if (url) {
      var qs = '?event=' + encodeURIComponent(name) + '&detail=' + encodeURIComponent(params.method || '');
      fetch(url + qs, { mode: 'no-cors' }).catch(function () {});
    }
  }

  function showPopup() {
    var popup = document.getElementById('apPopup');
    if (popup) popup.style.display = 'flex';
    if (!sessionStorage.getItem('ap_view_tracked')) {
      trackEvent('ap_popup_view');
      sessionStorage.setItem('ap_view_tracked', '1');
    }

    var apCountdownLive = window.apCountdownLive || window.location.search.includes('ap_countdown_live=1');
    if (apCountdownLive) {
      var AB_KEY = 'ap_ab_countdown_start';
      var abExpiresAt = localStorage.getItem(AB_KEY);
      if (!abExpiresAt) {
        abExpiresAt = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString();
        localStorage.setItem(AB_KEY, abExpiresAt);
      }
      startApCountdown(abExpiresAt);
    }
  }

  function celebrate() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var colors = ['#a9cdb9', '#ffffff', '#d4c4ad', '#b8bbb4', '#2d78fb', '#e8c8c8'];
    var layer = document.createElement('div');
    layer.className = 'ap-confetti';
    for (var i = 0; i < 48; i++) {
      var piece = document.createElement('i');
      piece.style.cssText = '--x:' + Math.random() * 100 + 'vw;--dx:' + (Math.random() * 160 - 80) + 'px;--r:' + (Math.random() * 720 - 360) + 'deg;--t:' + (2 + Math.random() * 1.5) + 's;--d:' + Math.random() * 0.6 + 's;--c:' + colors[i % colors.length];
      layer.appendChild(piece);
    }
    document.body.appendChild(layer);
    setTimeout(function () { layer.remove(); }, 4500);
  }

  function hidePopup() {
    var popup = document.getElementById('apPopup');
    if (popup) popup.style.display = 'none';
  }

function handleCloseButton(onClose) {
    var closeBtn = document.getElementById('apClose');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        onClose && onClose();
        hidePopup();
      });
    }
  }

  function handleDeclineButtons() {
    var declineBtn = document.getElementById('apDecline');
    if (declineBtn) {
      declineBtn.addEventListener('click', function () {
        if (getAccess().status !== 'declined') trackEvent('ap_decline');
        setAccess({ status: 'declined' });
        window.location.href = '/';
      });
    }
    var clientLink = document.querySelector('.ap__decline-link');
    if (clientLink) {
      clientLink.addEventListener('click', function (e) {
        e.preventDefault();
        if (getAccess().status !== 'declined') trackEvent('ap_decline');
        setAccess({ status: 'declined' });
        window.location.href = clientLink.getAttribute('href');
      });
    }
  }

  function showToast(onDone) {
    var toast   = document.getElementById('apToast');
    var bar     = document.getElementById('apToastBar');
    var duration = ((window.apConfig && window.apConfig.toastDuration) || 5) * 1000;

    if (!toast) { onDone && onDone(); return; }

    toast.classList.add('is-visible');
    if (bar) {
      bar.style.transition = 'transform ' + (duration / 1000) + 's linear';
      requestAnimationFrame(function () { bar.style.transform = 'scaleX(0)'; });
    }

    setTimeout(function () {
      toast.classList.add('is-hiding');
      setTimeout(function () {
        toast.classList.remove('is-visible', 'is-hiding');
        onDone && onDone();
      }, 400);
    }, duration);
  }

  /* ── Écouter l'expiration du countdown — TOUJOURS enregistré ── */
  document.addEventListener('vx:promo-expired', function () {
    var access = getAccess();

    if (access.status === 'member') {
      setAccess({ status: 'expired' });
      window.location.reload();
    }

    if (access.status === 'member_15min') {
      setAccess({ status: 'expired2' });
      window.location.href = '/';
    }
  });

  /* ══════════════════════════════════════════
     INIT
  ══════════════════════════════════════════ */

  if (window.apConfig && window.apConfig.trackingUrl) {
    localStorage.setItem('ap_tracking_url', window.apConfig.trackingUrl);
  }

  /* Lien de relance — remet le compteur à 0 (paramètre discret, style UTM) */
  if (window.location.search.includes('ref=vk29rq')) {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem('ap_ab_countdown_start');
  }

  var access = getAccess();
  var now    = new Date();

  var apForm    = document.getElementById('apForm');
  var submitBtn = apForm && apForm.querySelector('.ap__btn');
  var apEmail   = document.getElementById('apEmail');
  var apFormWrap = document.getElementById('apFormWrap');

  if (apEmail && submitBtn) {
    apEmail.addEventListener('input', function () {
      var hasText = apEmail.value.trim().length > 0;
      submitBtn.classList.toggle('is-armed', hasText);
      if (apFormWrap) apFormWrap.classList.toggle('is-typing', hasText);
    });
  }

  if (apForm && submitBtn) {
    apForm.addEventListener('submit', function () {
      submitBtn.classList.add('is-loading');
    });
  }

  /* Retour après inscription Shopify native */
  if (window.location.search.includes('customer_posted=true')) {
    var expiresAt = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString();
    setAccess({ status: 'member', expiresAt: expiresAt });
    access = { status: 'member', expiresAt: expiresAt };
    var signupSource = window.location.hash.includes('apppForm-') ? 'product_block' : 'popup';
    trackEvent('ap_signup_success', { method: signupSource });
    window.history.replaceState(null, '', window.location.pathname);

    /* Cacher les formulaires (ap-product-promo) immédiatement */
    document.dispatchEvent(new CustomEvent('vx:countdown', {
      detail: { expiresAtISO: expiresAt }
    }));

    /* Fermer la popup et afficher le toast de confirmation */
    hidePopup();
    showToast();
    celebrate();
    var picker = document.querySelector('.variant-picker__option:has(.color-carousel) .variant-picker__option-info') || document.querySelector('.product-info__multi-size-picker');
    if (picker) { setTimeout(function () { picker.scrollIntoView({ behavior: 'smooth' }); }, 600); setTimeout(function () { picker.scrollIntoView({ behavior: 'smooth' }); }, 1800); }
    return;
  }

  /* Vérifier expiration */
  if (access.status === 'member' && new Date(access.expiresAt) < now) {
    setAccess({ status: 'expired' });
    access = { status: 'expired' };
  }

  if (access.status === 'member_15min' && new Date(access.expiresAt) < now) {
    setAccess({ status: 'expired2' });
    access = { status: 'expired2' };
  }

  /* ── Membre valide → cacher popup + countdown ── */
  if (access.status === 'member' || access.status === 'member_15min') {
    hidePopup();
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent('vx:countdown', {
        detail: { expiresAtISO: access.expiresAt }
      }));
    }, 0);
    return;
  }

  /* ── Dismissed → accès libre sans countdown ── */
  if (access.status === 'dismissed') {
    return;
  }

  /* ── Expiré 1ère fois → popup avec bouton réactiver 15min ── */
  if (access.status === 'expired') {
    var SHOW_REACTIVATION_POPUP = false;
    if (!SHOW_REACTIVATION_POPUP) return;
    var popup = document.getElementById('apPopup');
    if (popup) popup.classList.add('is-expired');

    var reactivateBtn = document.getElementById('apReactivate');
    if (reactivateBtn) {
      reactivateBtn.addEventListener('click', function () {
        reactivateBtn.classList.add('is-loading');
        trackEvent('ap_reactivate');

        var cfg     = (window.apConfig && window.apConfig.expired) || {};
        var expires = new Date(Date.now() + (cfg.minutes || 15) * 60 * 1000).toISOString();
        setAccess({ status: 'member_15min', expiresAt: expires });
        document.dispatchEvent(new CustomEvent('vx:countdown', {
          detail: { expiresAtISO: expires }
        }));

        setTimeout(function () {
          hidePopup();
        }, 1500);
      });
    }

    showPopup();
    handleDeclineButtons();
    handleCloseButton(function () { trackEvent('ap_dismiss'); });
    return;
  }

  /* ── Expiré 2ème fois → redirect direct homepage ── */
  if (access.status === 'expired2') {
    window.location.href = '/';
    return;
  }

  /* ── Première visite → popup normale ── */
  if (!window.location.search.includes('labergebypass=1')) {
    showPopup();
    handleDeclineButtons();
    handleCloseButton(function () {
      setAccess({ status: 'dismissed' });
      trackEvent('ap_dismiss');
    });
  }

})();

(function () {
  'use strict';
  const cache = new Map();

  const overlay     = document.getElementById('legalModalOverlay');
  const closeButton = document.getElementById('legalModalCloseButton');
  const contentArea = document.querySelector('.legal-modal-scroll-area');

  if (!overlay) return;

  let lastClick = 0;

  function reset() {
    contentArea.innerHTML = '<div class="legal-modal-loader"></div>';
  }

  function close() {
    overlay.style.display = 'none';
    reset();
  }

  async function load(url) {
    if (!cache.has(url)) {
      const html = await fetch(url, { credentials: 'same-origin' }).then(r => r.text());
      const doc  = new DOMParser().parseFromString(html, 'text/html');
      cache.set(url, {
        title:   doc.title,
        content: doc.querySelector('.shopify-policy__container')?.cloneNode(true) ?? null
      });
    }
    return cache.get(url);
  }

  function getUrl(link) {
    const href = link?.getAttribute('href');
    if (!href || /^(#|mailto:|tel:)/.test(href)) return null;
    try {
      const url = new URL(href, location.href);
      return url.origin === location.origin ? url.href : null;
    } catch { return null; }
  }

  function getLink(target) {
    return target?.closest?.('.footer__block--menu a, .fm__block a, .accordion-list__content a[href*="/policies/"], a[data-page-popup]');
  }
  document.addEventListener('mouseover', e => {
    const url = getUrl(getLink(e.target));
    if (url) load(url).catch(() => {});
  }, { passive: true });
  document.addEventListener('click', async e => {
    const url = getUrl(getLink(e.target));
    if (!url) return;
    e.preventDefault();
    const token = ++lastClick;
    reset();
    overlay.style.display = 'flex';
    const { content } = await load(url).catch(() => ({ content: null }));
    if (token !== lastClick) return;
    contentArea.replaceChildren(content?.cloneNode(true) ?? Object.assign(document.createElement('p'), { textContent: 'Erreur de chargement.' }));
  });

  closeButton?.addEventListener('click', close);
  overlay.addEventListener('click', e => { if (e.target === overlay) close(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

})();